import React from 'react';
import { Box, Heading, Page, PageContent } from 'grommet';
import { JobForm, JobService } from '@enrich/shared-lib';
import { useNavigate, useParams } from 'react-router-dom';

export const NewJobForm = () => {
    const navigate = useNavigate();
    const { companySlug } = useParams();

    const handleSubmit = async (jobData) => {
        const result = await new JobService().createJob(jobData);
        navigate(`/${companySlug}/jobs/${result.data.id}`);
    };

    return (
        <Page
            kind="full"
            pad={{ top: '30px', horizontal: 'medium', bottom: '30px' }}>
            <PageContent align="center">
                <Heading level="2">Create New Job</Heading>
                <Box align="center">
                    <JobForm isClientView={true} onSubmit={handleSubmit} />
                </Box>
            </PageContent>
        </Page>
    );
};
